// import axios from "axios";
// import React, { useEffect } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { API_BASE_URL } from "../../config";
// import Swal from 'sweetalert2';

// const AddSubscriptionPlanNew = () => {
//   const { id } = useParams(); // Get ID from URL params for edit mode
//   const isEditMode = Boolean(id);
//   const navigate = useNavigate();
  
//   // Add custom styles for SweetAlert2
//   React.useEffect(() => {
//     const style = document.createElement('style');
//     style.textContent = `
//       .custom-swal-container {
//         z-index: 10000;
//       }
//       .custom-swal-popup {
//         border-radius: 10px;
//         box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
//       }
//       .custom-swal-title {
//         font-size: 1.5rem;
//         color: #333;
//         margin-bottom: 1rem;
//       }
//       .custom-swal-content {
//         margin: 0;
//       }
//       .swal2-input, .swal2-textarea {
//         margin: 0 !important;
//         box-sizing: border-box;
//       }
//       .swal2-input:focus, .swal2-textarea:focus {
//         border-color: #3085d6 !important;
//         box-shadow: 0 0 5px rgba(48, 133, 214, 0.3) !important;
//         outline: none !important;
//       }
//     `;
//     document.head.appendChild(style);
    
//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);
  
//   const [planData, setPlanData] = React.useState({
//     name: "",
//     description: "",
//     html_description: "",
//     features: [],
//     monthly_price: "",
//     annual_price: "",
//     monthly_offer: "",
//     annual_offer: "",
//     is_free_trial: 0, // Default to 1 for edit mode
//     free_trial_days: "", // Default to 0 for new plans
//     is_for_attorney: 0, // Default to 0
//   });
  
//   const {
//     name,
//     description,
//     html_description,
//     monthly_price,
//     annual_price,
//     features,
//     monthly_offer,
//     annual_offer,
//     is_free_trial,
//     free_trial_days,
//     is_for_attorney,
//   } = planData;
  
//   const [masterFeatures, setMasterFeatures] = React.useState([]);
//   const [featureLoading, setFeatureLoading] = React.useState(false);
//   const [planLoading, setPlanLoading] = React.useState(false);
//   const [submitLoading, setSubmitLoading] = React.useState(false);
//   const [errors, setErrors] = React.useState({});

//   console.log("Plan Data:", planData);

//   useEffect(() => {
//     fetchMasterFeatures();
//     if (isEditMode) {
//       fetchPlanDetails();
//     }
//   }, [id]);

//   const fetchMasterFeatures = async () => {
//     setFeatureLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/get-features`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
//         },
//       });
//       setMasterFeatures(response.data.data);
//     } catch (error) {
//       console.error("Error fetching master features:", error);
//       Swal.fire({
//         title: 'Error!',
//         text: 'Failed to fetch features. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'OK'
//       });
//     } finally {
//       setFeatureLoading(false);
//     }
//   };

//   const fetchPlanDetails = async () => {
//     setPlanLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/get-plans-detils/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
//         },
//       });
//       const planDetails = response.data.data;
//     //   console.log(planDetails,"planDetails");
      
//       // Parse features from string to array
//       let parsedFeatures = planDetails?.features?.split(",").map(Number) || "";
//       // let parsedFeatures = [];
//       // console.log(parsedFeatures);
//       // try {
//       //   parsedFeatures = JSON.parse(planDetails?.features) || "";
//       // } catch (e) {
//       //   console.error("Error parsing features:", e);
//       // }
      
//       setPlanData({
//         name: planDetails.name || "",
//         description: planDetails.description || "",
//         html_description: planDetails.html_description || "",
//         features: parsedFeatures,
//         monthly_price: planDetails.monthly_price || "",
//         annual_price: planDetails.annual_price || "",
//         monthly_offer: planDetails.monthly_offer || "",
//         annual_offer: planDetails.annual_offer || "",
//         is_free_trial: planDetails.is_free_trial || 0, // Convert to boolean
//         is_for_attorney: planDetails.is_for_attorney || 0,
//         free_trial_days: planDetails.free_trial_days || 0, // Default to 0 for new plans
//       });
//     } catch (error) {
//       console.error("Error fetching plan details:", error);
//       Swal.fire({
//         title: 'Error!',
//         text: 'Failed to fetch plan details. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'OK'
//       });
//     } finally {
//       setPlanLoading(false);
//     }
//   };

//   // console.log(planData);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
    
//     if (name === "features") {
//       const featureId = parseInt(value);
//       setPlanData((prevData) => {
//         const currentFeatures = [...prevData.features];
//         if (checked) {
//           // Add feature if checked and not already present
//           if (!currentFeatures.includes(featureId)) {
//             currentFeatures.push(featureId);
//           }
//         } else {
//           // Remove feature if unchecked
//           const index = currentFeatures.indexOf(featureId);
//           if (index > -1) {
//             currentFeatures.splice(index, 1);
//           }
//         }
//         return {
//           ...prevData,
//           features: currentFeatures,
//         };
//       });
//     }else if (name === "is_free_trial") {
//       // Handle checkbox for free trial
//       setPlanData((prevData) => ({
//         ...prevData,
//         is_free_trial: checked ? 1 : 0, // Convert to integer for API
//       }));
//     } else if (name === "is_for_attorney") {
//           setPlanData((prevData) => ({
//         ...prevData,
//         is_for_attorney: checked ? 1 : 0, // Convert to integer for API
//       }));
//     } else {
//       setPlanData((prevData) => ({
//         ...prevData,
//         [name]: type === "checkbox" ? checked : value,
//       }));
//     }
    
//     // Clear error when user starts typing
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ""
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!name.trim()) newErrors.name = "Plan Name is required";
//     if (!monthly_price) newErrors.monthly_price = "Monthly Price is required";
//     if (!annual_price) newErrors.annual_price = "Annual Price is required";
//     if (features.length === 0) newErrors.features = "At least one feature is required";
    
//     // Validate numeric fields
//     if (monthly_price && isNaN(monthly_price)) {
//       newErrors.monthly_price = "Monthly Price must be a valid number";
//     }
//     if (annual_price && isNaN(annual_price)) {
//       newErrors.annual_price = "Annual Price must be a valid number";
//     }
//     if (monthly_offer && isNaN(monthly_offer)) {
//       newErrors.monthly_offer = "Monthly Offer must be a valid number";
//     }
//     if (annual_offer && isNaN(annual_offer)) {
//       newErrors.annual_offer = "Annual Offer must be a valid number";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleEditFeature = async (featureId) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/get-features-details/${featureId}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
//         },
//       });
      
//       const featureData = response.data.data;
      
//       const { value: formValues } = await Swal.fire({
//         title: 'Edit Feature',
//         html: `
//           <div style="text-align: left; max-width: 100%;">
//             <div style="margin-bottom: 20px;">
//               <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">Feature Name:</label>
//               <input id="swal-input-name" class="swal2-input" value="${featureData.name}" placeholder="Feature Name" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px;">
//             </div>
//             <div style="margin-bottom: 20px;">
//               <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">Description:</label>
//               <textarea id="swal-input-description" class="swal2-textarea" placeholder="Description" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; min-height: 80px; resize: vertical;">${featureData.description}</textarea>
//             </div>
//             <div style="margin-bottom: 20px;">
//               <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">Feature Key:</label>
//               <input id="swal-input-key" class="swal2-input" value="${featureData.feature_key}" placeholder="Feature Key" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px;">
//             </div>
//             <div style="margin-bottom: 20px;">
//               <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">Feature Type:</label>
//               <select id="swal-input-type" class="swal2-input" style="width: 100%; border: 1px solid #ddd; border-radius: 5px; font-size: 14px;">
//                 <option value="numeric" ${featureData.feature_type === 'numeric' ? 'selected' : ''}>Numeric</option>
//                 <option value="text" ${featureData.feature_type === 'text' ? 'selected' : ''}>Text</option>
//                 <option value="boolean" ${featureData.feature_type === 'boolean' ? 'selected' : ''}>Boolean</option>
//               </select>
//             </div>
//             <div style="margin-bottom: 20px;">
//               <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">Default Value:</label>
//               <input id="swal-input-default" class="swal2-input" value="${featureData.default_value}" placeholder="Default Value" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px;">
//             </div>
//             <div style="margin-bottom: 15px;">
//               <label style="display: flex; align-items: center; font-weight: bold; color: #333; cursor: pointer;">
//                 <input id="swal-input-active" type="checkbox" ${featureData.is_active ? 'checked' : ''} style="margin-right: 10px; transform: scale(1.2);">
//                 Is Active
//               </label>
//             </div>
//           </div>
//         `,
//         width: '600px',
//         padding: '2rem',
//         focusConfirm: false,
//         showCancelButton: true,
//         confirmButtonText: 'Update Feature',
//         cancelButtonText: 'Cancel',
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         customClass: {
//           container: 'custom-swal-container',
//           popup: 'custom-swal-popup',
//           title: 'custom-swal-title',
//           content: 'custom-swal-content'
//         },
//         preConfirm: () => {
//           const name = document.getElementById('swal-input-name').value.trim();
//           const description = document.getElementById('swal-input-description').value.trim();
//           const feature_key = document.getElementById('swal-input-key').value.trim();
//           const feature_type = document.getElementById('swal-input-type').value;
//           const default_value = document.getElementById('swal-input-default').value.trim();
//           const is_active = document.getElementById('swal-input-active').checked;
          
//           // Validation
//           if (!name) {
//             Swal.showValidationMessage('Feature Name is required');
//             return false;
//           }
          
//           if (!description) {
//             Swal.showValidationMessage('Description is required');
//             return false;
//           }
          
//           if (!feature_key) {
//             Swal.showValidationMessage('Feature Key is required');
//             return false;
//           }
          
//           // Validate feature key format (should be lowercase with underscores)
//           const featureKeyRegex = /^[a-z][a-z0-9_]*$/;
//           if (!featureKeyRegex.test(feature_key)) {
//             Swal.showValidationMessage('Feature Key should start with a letter and contain only lowercase letters, numbers, and underscores');
//             return false;
//           }
          
//           // Validate default value based on feature type
//           if (feature_type === 'numeric' && default_value && isNaN(default_value)) {
//             Swal.showValidationMessage('Default Value must be a valid number for numeric feature type');
//             return false;
//           }
          
//           if (feature_type === 'boolean' && default_value && !['true', 'false', '1', '0'].includes(default_value.toLowerCase())) {
//             Swal.showValidationMessage('Default Value for boolean type should be true/false or 1/0');
//             return false;
//           }
          
//           return {
//             name,
//             description,
//             feature_key,
//             feature_type,
//             default_value,
//             is_active: is_active ? 1 : 0
//           };
//         }
//       });

//       if (formValues) {
//         try {
//           // Show loading state
//           Swal.fire({
//             title: 'Updating Feature...',
//             text: 'Please wait while we update the feature.',
//             icon: 'info',
//             allowOutsideClick: false,
//             showConfirmButton: false,
//             didOpen: () => {
//               Swal.showLoading();
//             }
//           });

//           // Make API call to update the feature
//           const updateResponse = await axios.post(
//             `${API_BASE_URL}/update-features/${featureId}`,
//             formValues,
//             {
//               headers: {
//                 Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
//                 'Content-Type': 'application/json',
//               },
//             }
//           );

//           // Show success message
//           Swal.fire({
//             title: 'Success!',
//             text: 'Feature updated successfully.',
//             icon: 'success',
//             confirmButtonText: 'OK'
//           }).then(() => {
//             fetchMasterFeatures(); // Refresh the features list
//           });

//         } catch (updateError) {
//           console.error("Error updating feature:", updateError);
          
//           // Show error message with details if available
//           const errorMessage = updateError.response?.data?.message || 
//                               updateError.response?.data?.error || 
//                               'Failed to update feature. Please try again.';
          
//           Swal.fire({
//             title: 'Error!',
//             text: errorMessage,
//             icon: 'error',
//             confirmButtonText: 'OK'
//           });
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching feature details:", error);
//       Swal.fire({
//         title: 'Error!',
//         text: 'Failed to fetch feature details. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'OK'
//       });
//     }
//   };

//   const checkForDuplicateFeatures = (featuresArray) => {

//     const featureKeys = featuresArray.map((featureId) => {
//       const feature = masterFeatures.find((f) => f.id === featureId);
//       return feature?.feature_key;
//     });

//     const isDuplicate = featureKeys.some((key, i) => featureKeys.indexOf(key) !== i);
//    // want to get conflicting feature key
//     const conflictingFeature = featureKeys.find((key, i) => featureKeys.indexOf(key) !== i);

//     if (isDuplicate) {
//       Swal.fire({
//         title: 'Error!',
//         text: `Features with same key cannot be added to the plan. Please try again. Aviod Same feature type/key. Conflicting Feature Key: ${conflictingFeature}`,
//         icon: 'error',
//         confirmButtonText: 'OK'
//       });
//     }

//     return !isDuplicate;
  
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }

//     // Check for duplicate features
//     if (!checkForDuplicateFeatures(features)) {
//       return;
//     }

//     setSubmitLoading(true);
    
//     const payload = {
//       name: name.trim(),
//       description: description.trim(),
//       html_description: html_description.trim(),
//       features,
//       monthly_price: parseFloat(monthly_price),
//       annual_price: parseFloat(annual_price),
//       monthly_offer: monthly_offer ? parseFloat(monthly_offer) : 0,
//       annual_offer: annual_offer ? parseFloat(annual_offer) : 0,
//       is_free_trial: is_free_trial == 1 ? 1 : 0, // Convert to integer for API
//       is_for_attorney: is_for_attorney == 1 ? 1 : 0, // Convert to integer for API
//       free_trial_days: free_trial_days ? parseInt(free_trial_days) : 0, // Convert to integer for API
//     };

//     try {
//       let response;
//       if (isEditMode) {
//         response = await axios.post(`${API_BASE_URL}/update-plans/${id}`, payload, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
//             'Content-Type': 'application/json',
//           },
//         });
//       } else {
//         response = await axios.post(`${API_BASE_URL}/create-subscription-plans`, payload, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
//             'Content-Type': 'application/json',
//           },
//         });
//       }
      
//       Swal.fire({
//         title: 'Success!',
//         text: `Plan ${isEditMode ? 'updated' : 'created'} successfully.`,
//         icon: 'success',
//         confirmButtonText: 'OK'
//       }).then(() => {
//         // Redirect to manage plans page or reset form
//         navigate('/cms/manage-subscription-plan');
//       });
      
//     } catch (error) {
//       console.error("Error submitting plan:", error);
//       Swal.fire({
//         title: 'Error!',
//         text: `Failed to ${isEditMode ? 'update' : 'create'} plan. Please try again.`,
//         icon: 'error',
//         confirmButtonText: 'OK'
//       });
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   if (planLoading) {
//     return (
//        <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="row">
//               <div className="col-12">
//                 <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
//                   <div className="spinner-border text-primary" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                   <span className="ms-2">Loading plan details...</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="row">
//               <div className="col-12">
//                 <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                   <h4 className="mb-sm-0 font-size-18">
//                     {isEditMode ? 'Edit Plan' : 'Add Plan'}
//                   </h4>
//                   <div className="page-title-right">
//                     <ol className="breadcrumb m-0">
//                       <li className="breadcrumb-item">
//                         <a href="javascript: void(0);">CMS</a>
//                       </li>
//                       <li className="breadcrumb-item">
//                         <Link to={"/cms/manage-subscription-plan"}>
//                           Manage Plan
//                         </Link>
//                       </li>
//                       <li className="breadcrumb-item active">
//                         {isEditMode ? 'Edit Plan' : 'Add Plan'}
//                       </li>
//                     </ol>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-xl-12">
//               <div className="row">
//                 <div className="col-lg-12">
//                   <div className="card">
//                     <div className="card-body">
//                       <h4 className="card-title mb-4">
//                         {isEditMode ? 'Edit Plan' : 'Add Plan'}
//                       </h4>
//                       <form onSubmit={handleSubmit}>
//                         <div data-repeater-list="outer-group" className="outer">
//                           <div data-repeater-item className="outer row">
//                             <div className="col-md-6 col-lg-12">
//                               {/* Plan Name */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="taskname" className="col-form-label col-lg-2">
//                                   Plan Name
//                                 </label>
//                                 <div className="col-lg-10">
//                                   <input
//                                     id="taskname"
//                                     name="name"
//                                     type="text"
//                                     value={name}
//                                     className={`form-control ${errors.name ? "is-invalid" : ""}`}
//                                     placeholder="Enter Plan Name..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.name && (
//                                     <div className="text-danger">{errors.name}</div>
//                                   )}
//                                 </div>
//                               </div>

//                               {/* Description */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="description" className="col-form-label col-lg-2">
//                                   Description
//                                 </label>
//                                 <div className="col-lg-10">
//                                   <textarea
//                                     id="description"
//                                     name="description"
//                                     // type="text"
//                                     rows={5}
//                                     value={description}
//                                     className={`form-control ${errors.description ? "is-invalid" : ""}`}
//                                     placeholder="Enter Description..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.description && (
//                                     <div className="text-danger">{errors.description}</div>
//                                   )}
//                                 </div>
//                               </div>

//                               {/* HTML Description */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="html_description" className="col-form-label col-lg-2">
//                                   Description(HTML)
//                                 </label>
//                                 <div className="col-lg-10">
//                                   <textarea
//                                     id="html_description"
//                                     name="html_description"
//                                     rows="5"
//                                     value={html_description}
//                                     className={`form-control ${errors.html_description ? "is-invalid" : ""}`}
//                                     placeholder="Enter HTML Description..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.html_description && (
//                                     <div className="text-danger">{errors.html_description}</div>
//                                   )}
//                                 </div>
//                               </div>

//                               {/* Is For Attorney */}
//                                    <div className="form-group row mb-4">
//                                 <label htmlFor="is_for_attorney" className="col-form-label col-lg-2">
//                                   For Attorney/Professional
//                                 </label>
//                                 <div className="col-lg-6 d-flex align-items-center">
//                                   <input
//                                     id="is_for_attorney"
//                                     name="is_for_attorney"
//                                     type="checkbox"
//                                     value={is_for_attorney}
//                                     checked={is_for_attorney === 1}
//                                     className={`form-check-input mt-2 ${errors.is_for_attorney ? "is-invalid" : ""}`}
//                                     style={{ width: "20px", height: "20px" }}
//                                     placeholder="Enter is_for_attorney..."
//                                     onChange={handleInputChange}
//                                   />
//                                     <small className="form-text text-muted ms-2">
//                                     <span className="text-success"><b>Check</b></span> this box if you want to make this plan for <b>Attorney/Lawyers</b> <br/> <span className="text-danger"><b>Uncheck</b></span> this box if you want to make this plan for <b>Professional</b>.
//                                   </small>
//                                   {errors.is_for_attorney && (
//                                     <div className="text-danger">{errors.is_for_attorney}</div>
//                                   )}
//                                 </div>
                             
                              
//                               </div>

                            

//                               {/* Monthly Price */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="monthly_price" className="col-form-label col-lg-2">
//                                   Monthly Price
//                                 </label>
//                                 <div className="col-lg-10">
//                                   <input
//                                     id="monthly_price"
//                                     name="monthly_price"
//                                     type="number"
//                                     step="0.01"
//                                     value={monthly_price}
//                                     className={`form-control ${errors.monthly_price ? "is-invalid" : ""}`}
//                                     placeholder="Enter monthly price..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.monthly_price && (
//                                     <div className="text-danger">{errors.monthly_price}</div>
//                                   )}
//                                 </div>
//                               </div>

//                               {/* Annual Price */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="annual_price" className="col-form-label col-lg-2">
//                                   Annual Price
//                                 </label>
//                                 <div className="col-lg-10">
//                                   <input
//                                     id="annual_price"
//                                     name="annual_price"
//                                     type="number"
//                                     step="0.01"
//                                     value={annual_price}
//                                     className={`form-control ${errors.annual_price ? "is-invalid" : ""}`}
//                                     placeholder="Enter Annual Price..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.annual_price && (
//                                     <div className="text-danger">{errors.annual_price}</div>
//                                   )}
//                                 </div>
//                               </div>

//                               {/* Monthly Offer */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="monthly_offer" className="col-form-label col-lg-2">
//                                   Monthly Offer
//                                 </label>
//                                 <div className="col-lg-10">
//                                   <input
//                                     id="monthly_offer"
//                                     name="monthly_offer"
//                                     type="number"
//                                     step="0.01"
//                                     value={monthly_offer}
//                                     className={`form-control ${errors.monthly_offer ? "is-invalid" : ""}`}
//                                     placeholder="Enter monthly offer..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.monthly_offer && (
//                                     <div className="text-danger">{errors.monthly_offer}</div>
//                                   )}
//                                 </div>
//                               </div>

//                               {/* Annual Offer */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="annual_offer" className="col-form-label col-lg-2">
//                                   Annual Offer
//                                 </label>
//                                 <div className="col-lg-10">
//                                   <input
//                                     id="annual_offer"
//                                     name="annual_offer"
//                                     type="number"
//                                     step="0.01"
//                                     value={annual_offer}
//                                     className={`form-control ${errors.annual_offer ? "is-invalid" : ""}`}
//                                     placeholder="Enter annual offer..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.annual_offer && (
//                                     <div className="text-danger">{errors.annual_offer}</div>
//                                   )}
//                                 </div>
//                               </div>
//                               {/* Free Trial */}
//                               <div className="form-group row mb-4">
//                                 <label htmlFor="is_free_trial" className="col-form-label col-lg-2">
//                                   Free Trial
//                                 </label>
//                                 <div className="col-lg-4 d-flex align-items-center">
//                                   <input
//                                     id="is_free_trial"
//                                     name="is_free_trial"
//                                     type="checkbox"
//                                     value={is_free_trial}
//                                     checked={is_free_trial === 1}
//                                     className={`form-check-input mt-2 ${errors.is_free_trial ? "is-invalid" : ""}`}
//                                     style={{ width: "20px", height: "20px" }}
//                                     placeholder="Enter annual offer..."
//                                     onChange={handleInputChange}
//                                   />
//                                     <small className="form-text text-muted ms-2">
//                                     Check this box if you want to make this plan a <b>Free Trial</b>.
//                                   </small>
//                                   {errors.is_free_trial && (
//                                     <div className="text-danger">{errors.is_free_trial}</div>
//                                   )}
//                                 </div>
                             
                              
//                               </div>

//                               {/* Free Trial Days */}
//                                  <div className="form-group row mb-4">
//                                 <label htmlFor="free_trial_days" className="col-form-label col-lg-2">
//                                   Free Trial Days
//                                 </label>
//                                 <div className="col-lg-10">
//                                  <input
//                                     id="free_trial_days"
//                                     name="free_trial_days"
//                                     type="number"
//                                     step={"1"}
//                                     value={free_trial_days}
//                                     className={`form-control ${errors.free_trial_days ? "is-invalid" : ""}`}
//                                     placeholder="Enter free trial days..."
//                                     onChange={handleInputChange}
//                                   />
//                                   {errors.free_trial_days && (
//                                     <div className="text-danger">{errors.free_trial_days}</div>
//                                   )}
//                                 </div>
//                               </div>
                                    

//                               {/* Features */}
//                               <div className="form-group row mb-4">
//                                 <label className="col-form-label col-lg-2">Features</label>
//                                 <div className="col-lg-10">
//                                   {featureLoading ? (
//                                     <div className="d-flex justify-content-center">
//                                       <div className="spinner-border spinner-border-sm" role="status">
//                                         <span className="visually-hidden">Loading...</span>
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     <div className="row">
//                                       {masterFeatures?.sort((a, b) => a.feature_order - b.feature_order)?.map((item) => (
//                                         <div key={item?.id} className="col-md-6 col-lg-4 mb-3">
//                                           <div className={`card h-100 ${features.includes(item?.id) ? "checked-border" : ""}`} style={{overflow: "hidden"}}>
//                                             <div className="card-body p-3">
//                                               <div className="form-check mb-2">
//                                                 <input
//                                                   className="form-check-input"
//                                                   type="checkbox"
//                                                   id={`feature-${item.id}`}
//                                                   name="features"
//                                                   value={item?.id}
//                                                   checked={features.includes(item?.id)}
//                                                   onChange={handleInputChange}
//                                                 />
//                                                 <label
//                                                   className="form-check-label fw-medium"
//                                                   htmlFor={`feature-${item.id}`}
//                                                 >
//                                                   {item?.name}
//                                                 </label>
//                                               </div>
//                                               <div className="d-flex justify-content-between align-items-center">
//                                                 <small className="text-muted">
//                                                   {item?.description?.length > 50
//                                                     ? `${item.description.substring(0, 50)}...`
//                                                     : item?.description}
//                                                 </small>
//                                                 <button
//                                                   type="button"
//                                                   className="btn btn-sm btn-outline-primary"
//                                                   onClick={() => handleEditFeature(item.id)}
//                                                   title="Edit Feature"
//                                                 >
//                                                   <i className="fas fa-edit"></i>
//                                                 </button>
//                                               </div>
//                                             </div>
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   )}
//                                   {errors.features && (
//                                     <div className="text-danger mt-2">{errors.features}</div>
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>

//                         <div className="row justify-content-end">
//                           <div className="col-lg-10">
//                             <div className="d-flex gap-2">
//                               <Link
//                                 to="/cms/manage-subscription-plan"
//                                 className="btn btn-secondary"
//                               >
//                                 Cancel
//                               </Link>
//                               <button
//                                 type="submit"
//                                 className="btn btn-primary"
//                                 disabled={submitLoading}
//                               >
//                                 {submitLoading ? (
//                                   <>
//                                     <span className="spinner-border spinner-border-sm me-2" role="status">
//                                       <span className="visually-hidden">Loading...</span>
//                                     </span>
//                                     {isEditMode ? 'Updating...' : 'Creating...'}
//                                   </>
//                                 ) : (
//                                   isEditMode ? 'Update Plan' : 'Add Plan'
//                                 )}
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddSubscriptionPlanNew;



import axios from "axios";
import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import Swal from 'sweetalert2';
import { Editor } from "@tinymce/tinymce-react";

/* Same editor setup as the Manage Content pages — one look for every rich
   description in the CMS, and `valid_elements` left wide open so pasted markup
   survives instead of being stripped. */
const TINYMCE_CONFIG = {
  plugins:
    "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
  table_default_attributes: { border: "5" },
  valid_elements: "*[*]",
};

/* ─── Scoped Styles ───────────────────────────────────────────────────────── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .asp-scope {
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  /* ── Page title ── */
  .asp-scope .page-title-box {
    padding: 6px 0 22px;
    border-bottom: 1px solid #f0f2f7;
    margin-bottom: 26px;
  }
  .asp-scope .page-title-box h4 {
    font-size: 20px;
    font-weight: 800;
    color: #1a1f36;
    letter-spacing: -0.3px;
    margin: 0;
  }
  .asp-scope .breadcrumb { background: none; padding: 0; margin: 0; }
  .asp-scope .breadcrumb-item a { color: #8b92a9; text-decoration: none; font-size: 13px; font-weight: 500; }
  .asp-scope .breadcrumb-item.active { color: #3b5bdb; font-size: 13px; font-weight: 600; }
  .asp-scope .breadcrumb-item + .breadcrumb-item::before { color: #c8cdd9; }

  /* ── Card ── */
  .asp-scope .card {
    border: 1px solid #eaecf4 !important;
    border-radius: 16px !important;
    box-shadow: 0 2px 20px rgba(28,36,75,0.07) !important;
    overflow: visible !important;
  }
  .asp-scope .card-body { padding: 0 !important; }

  /* ── Card Header ── */
  .asp-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 22px 28px 20px;
    border-bottom: 1px solid #f0f2f7;
    background: #fafbff;
    border-radius: 16px 16px 0 0;
  }
  .asp-card-icon {
    width: 40px; height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #eef1fb, #dde3f8);
    border: 1.5px solid #d0d8f5;
    display: flex; align-items: center; justify-content: center;
    color: #3b5bdb;
    font-size: 16px;
    flex-shrink: 0;
  }
  .asp-card-title {
    font-size: 15px;
    font-weight: 800;
    color: #1a1f36;
    letter-spacing: -0.2px;
  }
  .asp-card-subtitle {
    font-size: 12.5px;
    color: #8b92a9;
    font-weight: 500;
    margin-top: 1px;
  }
  .asp-mode-badge {
    margin-left: auto;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .asp-mode-badge-edit   { background: #fff8ec; color: #e07b00; border: 1px solid #fde8b8; }
  .asp-mode-badge-create { background: #edfaf3; color: #0a8a4a; border: 1px solid #b8f0d4; }

  /* ── Form body ── */
  .asp-form-body { padding: 28px 28px 24px; }

  /* ── Section divider ── */
  .asp-section {
    margin-bottom: 32px;
  }
  .asp-section-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    font-weight: 700;
    color: #8b92a9;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 18px;
  }
  .asp-section-label::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #f0f2f7;
  }

  /* ── Form Group override ── */
  .asp-scope .form-group.row { margin-bottom: 0 !important; }
  .asp-field { margin-bottom: 20px; }
  .asp-label {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: #1a1f36;
    margin-bottom: 7px;
    letter-spacing: -0.1px;
  }
  .asp-label span.asp-req { color: #d92b2b; margin-left: 2px; }

  /* ── Inputs ── */
  .asp-scope .form-control {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #1a1f36;
    background: #fff;
    border: 1.5px solid #e2e6f0;
    border-radius: 10px;
    padding: 10px 14px;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
    box-shadow: 0 1px 3px rgba(28,36,75,0.04);
  }
  .asp-scope .form-control:focus {
    border-color: #3b5bdb;
    box-shadow: 0 0 0 3px rgba(59,91,219,0.12);
    outline: none;
  }
  .asp-scope .form-control.is-invalid {
    border-color: #d92b2b;
    box-shadow: 0 0 0 3px rgba(217,43,43,0.10);
  }
  .asp-scope .form-control::placeholder { color: #b0b8cc; font-weight: 400; }
  .asp-scope textarea.form-control { resize: vertical; min-height: 90px; line-height: 1.55; }

  /* ── Error text ── */
  .asp-error {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 600;
    color: #d92b2b;
    margin-top: 5px;
  }
  .asp-error::before { content: '⚠'; font-size: 11px; }

  /* ── Hint text ── */
  .asp-hint {
    font-size: 12px;
    color: #8b92a9;
    font-weight: 500;
    margin-top: 5px;
    line-height: 1.5;
  }

  /* ── Toggle / Checkbox Row ── */
  .asp-toggle-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #f8f9fe;
    border: 1.5px solid #e2e6f0;
    border-radius: 10px;
    padding: 14px 16px;
    transition: border-color 0.18s ease;
  }
  .asp-toggle-row:focus-within { border-color: #3b5bdb; }
  .asp-toggle-row .form-check-input {
    width: 20px !important;
    height: 20px !important;
    margin-top: 2px;
    flex-shrink: 0;
    border: 2px solid #c8d0e8;
    border-radius: 5px;
    cursor: pointer;
    accent-color: #3b5bdb;
  }
  .asp-toggle-row .form-check-input:checked { background-color: #3b5bdb; border-color: #3b5bdb; }
  .asp-toggle-info strong.ok  { color: #0a8a4a; }
  .asp-toggle-info strong.no  { color: #d92b2b; }
  .asp-toggle-info strong     { font-weight: 700; }
  .asp-toggle-info small      { font-size: 13px; color: #5a6180; line-height: 1.5; }

  /* ── Features Grid ── */
  .asp-feature-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
  }
  .asp-feature-card {
    background: #fff;
    border: 1.5px solid #e2e6f0;
    border-radius: 12px;
    padding: 14px;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
    cursor: pointer;
    position: relative;
    min-height: 0;
    overflow: hidden;
    word-break: break-word;
  }
  .asp-feature-card:hover { border-color: #b0bce8; box-shadow: 0 2px 10px rgba(59,91,219,0.08); }
  .asp-feature-card.asp-feature-checked {
    border-color: #3b5bdb;
    background: #f4f6fd;
    box-shadow: 0 2px 12px rgba(59,91,219,0.12);
  }
  .asp-feature-card-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
    min-width: 0;
  }
  .asp-feature-check-label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    cursor: pointer;
    flex: 1;
    min-width: 0;
  }
  .asp-feature-check-label input[type="checkbox"] {
    width: 16px !important;
    height: 16px !important;
    margin-top: 2px;
    flex-shrink: 0;
    accent-color: #3b5bdb;
    cursor: pointer;
    border-radius: 4px;
  }
  .asp-feature-name {
    font-size: 13.5px;
    font-weight: 700;
    color: #1a1f36;
    line-height: 1.35;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
  }
  .asp-feature-desc {
    font-size: 12px;
    color: #8b92a9;
    font-weight: 400;
    margin-top: 4px;
    line-height: 1.45;
  }
  .asp-feature-edit-btn {
    width: 28px; height: 28px;
    border-radius: 7px;
    border: 1.5px solid #e2e6f0;
    background: #fff;
    color: #8b92a9;
    display: flex; align-items: center; justify-content: center;
    font-size: 12px;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.15s ease;
  }
  .asp-feature-edit-btn:hover {
    border-color: #3b5bdb;
    background: #eef1fb;
    color: #3b5bdb;
  }
  .asp-feature-selected-tick {
    position: absolute;
    top: 10px; right: 10px;
    width: 18px; height: 18px;
    background: #3b5bdb;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    color: #fff;
    font-size: 10px;
    opacity: 0;
    transform: scale(0.6);
    transition: all 0.18s ease;
  }
  .asp-feature-checked .asp-feature-selected-tick { opacity: 1; transform: scale(1); }

  /* ── Feature loading skeleton ── */
  .asp-skeleton {
    background: linear-gradient(90deg, #f0f2f7 25%, #e8ebf5 50%, #f0f2f7 75%);
    background-size: 200% 100%;
    animation: asp-shimmer 1.4s infinite;
    border-radius: 8px;
    display: block;
  }
  @keyframes asp-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }

  /* ── Form footer ── */
  .asp-form-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 18px 28px 24px;
    border-top: 1px solid #f0f2f7;
    background: #fafbff;
    border-radius: 0 0 16px 16px;
  }
  .asp-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 24px;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    text-decoration: none !important;
    transition: all 0.18s ease;
    letter-spacing: -0.1px;
  }
  .asp-btn:disabled { opacity: 0.65; cursor: not-allowed; }
  .asp-btn-cancel {
    background: #f0f2f7;
    color: #5a6180;
    border: 1.5px solid #e2e6f0;
  }
  .asp-btn-cancel:hover { background: #e4e8f0; color: #1a1f36; }
  .asp-btn-submit {
    background: linear-gradient(135deg, #3b5bdb 0%, #4c6ef5 100%);
    color: #fff;
    box-shadow: 0 4px 14px rgba(59,91,219,0.35);
  }
  .asp-btn-submit:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(59,91,219,0.45);
  }

  /* ── Loading state ── */
  .asp-page-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    gap: 14px;
  }
  .asp-page-loader .spinner-border { width: 36px; height: 36px; border-width: 3px; color: #3b5bdb; }
  .asp-page-loader p { font-size: 14px; font-weight: 600; color: #8b92a9; margin: 0; }

  /* ── Spinner in button ── */
  .asp-scope .spinner-border-sm { width: 14px; height: 14px; border-width: 2px; }

  /* ── Two-col grid for price fields ── */
  .asp-price-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  @media (max-width: 640px) {
    .asp-price-grid { grid-template-columns: 1fr; }
    .asp-feature-grid { grid-template-columns: 1fr; }
  }
`;

const AddSubscriptionPlanNew = () => {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

      /* ── Backdrop ── */
      .ef-swal-container { z-index: 10000 !important; }
      .ef-swal-backdrop  { background: rgba(15,20,40,0.55) !important; backdrop-filter: blur(4px); }

      /* ── Popup shell ── */
      .ef-swal-popup {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        border-radius: 20px !important;
        padding: 0 !important;
        overflow: hidden !important;
        box-shadow: 0 24px 64px rgba(15,20,60,0.18), 0 2px 16px rgba(15,20,60,0.10) !important;
        border: 1px solid #eaecf4 !important;
      }

      /* ── Title bar ── */
      .ef-swal-popup .swal2-header {
        background: linear-gradient(135deg, #3b5bdb 0%, #4c6ef5 100%);
        padding: 22px 28px 18px !important;
        border-bottom: none !important;
        align-items: flex-start !important;
      }
      .ef-swal-popup .swal2-title {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-size: 17px !important;
        font-weight: 800 !important;
        color: #fff !important;
        letter-spacing: -0.3px !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
      }
      .ef-swal-popup .swal2-title::before {
        content: '';
        display: inline-block;
        width: 32px; height: 32px;
        background: rgba(255,255,255,0.18);
        border-radius: 8px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5'%3E%3Cpath d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7'/%3E%3Cpath d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        flex-shrink: 0;
      }
      .ef-swal-popup .swal2-close {
        color: rgba(255,255,255,0.7) !important;
        font-size: 22px !important;
        top: 14px !important; right: 18px !important;
        width: 32px !important; height: 32px !important;
        border-radius: 8px !important;
        transition: background 0.15s ease !important;
      }
      .ef-swal-popup .swal2-close:hover { background: rgba(255,255,255,0.15) !important; color: #fff !important; }

      /* ── HTML content area ── */
      .ef-swal-popup .swal2-html-container {
        margin: 0 !important;
        padding: 24px 28px 8px !important;
        text-align: left !important;
        overflow-y: auto !important;
        max-height: 62vh !important;
      }

      /* ── Field groups inside modal ── */
      .ef-field { margin-bottom: 18px; }
      .ef-label {
        display: block;
        font-size: 12.5px;
        font-weight: 700;
        color: #1a1f36;
        margin-bottom: 6px;
        letter-spacing: -0.1px;
      }
      .ef-label span { color: #d92b2b; margin-left: 2px; }

      /* ── Inputs inside modal ── */
      .ef-input, .ef-textarea, .ef-select {
        width: 100% !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-size: 13.5px !important;
        font-weight: 500 !important;
        color: #1a1f36 !important;
        background: #fff !important;
        border: 1.5px solid #e2e6f0 !important;
        border-radius: 10px !important;
        padding: 10px 13px !important;
        margin: 0 !important;
        box-sizing: border-box !important;
        transition: border-color 0.18s ease, box-shadow 0.18s ease !important;
        box-shadow: 0 1px 3px rgba(28,36,75,0.04) !important;
        outline: none !important;
      }
      .ef-input::placeholder, .ef-textarea::placeholder { color: #b0b8cc !important; font-weight: 400 !important; }
      .ef-input:focus, .ef-textarea:focus, .ef-select:focus {
        border-color: #3b5bdb !important;
        box-shadow: 0 0 0 3px rgba(59,91,219,0.12) !important;
      }
      .ef-textarea { resize: vertical !important; min-height: 80px !important; line-height: 1.55 !important; }
      .ef-select { appearance: auto !important; cursor: pointer !important; }

      /* ── Two-col grid inside modal ── */
      .ef-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

      /* ── Toggle row inside modal ── */
      .ef-toggle-row {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #f8f9fe;
        border: 1.5px solid #e2e6f0;
        border-radius: 10px;
        padding: 12px 14px;
        cursor: pointer;
      }
      .ef-toggle-row input[type="checkbox"] {
        width: 18px !important; height: 18px !important;
        accent-color: #3b5bdb;
        cursor: pointer;
        flex-shrink: 0;
        margin: 0 !important;
      }
      .ef-toggle-label {
        font-size: 13px;
        font-weight: 600;
        color: #1a1f36;
        cursor: pointer;
      }
      .ef-toggle-hint { font-size: 12px; color: #8b92a9; margin-left: auto; font-weight: 500; }

      /* ── Divider ── */
      .ef-divider {
        height: 1px;
        background: #f0f2f7;
        margin: 20px 0;
      }
      .ef-section-label {
        font-size: 10.5px;
        font-weight: 700;
        color: #8b92a9;
        text-transform: uppercase;
        letter-spacing: 0.9px;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .ef-section-label::after { content: ''; flex: 1; height: 1px; background: #f0f2f7; }

      /* ── Validation message ── */
      .ef-swal-popup .swal2-validation-message {
        background: #fff1f0 !important;
        color: #d92b2b !important;
        font-size: 12.5px !important;
        font-weight: 600 !important;
        border-radius: 8px !important;
        margin: 8px 28px 0 !important;
        padding: 8px 14px !important;
        border: 1px solid #ffc9c6 !important;
      }
      .ef-swal-popup .swal2-validation-message::before { color: #d92b2b !important; }

      /* ── Actions bar ── */
      .ef-swal-popup .swal2-actions {
        padding: 16px 28px 22px !important;
        margin: 0 !important;
        gap: 10px !important;
        border-top: 1px solid #f0f2f7 !important;
        background: #fafbff !important;
        justify-content: flex-end !important;
      }
      .ef-swal-popup .swal2-confirm {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-size: 13.5px !important;
        font-weight: 700 !important;
        padding: 10px 24px !important;
        border-radius: 10px !important;
        background: linear-gradient(135deg, #3b5bdb 0%, #4c6ef5 100%) !important;
        box-shadow: 0 4px 14px rgba(59,91,219,0.35) !important;
        border: none !important;
        transition: all 0.18s ease !important;
        order: 2 !important;
      }
      .ef-swal-popup .swal2-confirm:hover {
        transform: translateY(-1px) !important;
        box-shadow: 0 8px 20px rgba(59,91,219,0.45) !important;
      }
      .ef-swal-popup .swal2-cancel {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-size: 13.5px !important;
        font-weight: 700 !important;
        padding: 10px 20px !important;
        border-radius: 10px !important;
        background: #f0f2f7 !important;
        color: #5a6180 !important;
        border: 1.5px solid #e2e6f0 !important;
        box-shadow: none !important;
        transition: all 0.18s ease !important;
        order: 1 !important;
      }
      .ef-swal-popup .swal2-cancel:hover { background: #e4e8f0 !important; color: #1a1f36 !important; }

      /* ── Feature key hint badge ── */
      .ef-key-hint {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 11px;
        font-weight: 600;
        color: #8b92a9;
        background: #f0f2f7;
        border-radius: 5px;
        padding: 2px 7px;
        margin-left: 6px;
        letter-spacing: 0;
        text-transform: none;
      }
    `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  const [planData, setPlanData] = React.useState({
    name: "", description: "", html_description: "", features: [],
    monthly_price: "", annual_price: "", monthly_offer: "", annual_offer: "",
    is_free_trial: 0, free_trial_days: "", is_for_attorney: 0,
  });

  const { name, description, html_description, monthly_price, annual_price,
    features, monthly_offer, annual_offer, is_free_trial, free_trial_days, is_for_attorney } = planData;

  const [masterFeatures, setMasterFeatures] = React.useState([]);
  const [featureLoading, setFeatureLoading] = React.useState(false);
  const [planLoading, setPlanLoading] = React.useState(false);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [errors, setErrors] = React.useState({});

  console.log("Plan Data:", planData);

  useEffect(() => {
    fetchMasterFeatures();
    if (isEditMode) fetchPlanDetails();
  }, [id]);

  const fetchMasterFeatures = async () => {
    setFeatureLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-features`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` },
      });
      setMasterFeatures(response.data.data);
    } catch (error) {
      console.error("Error fetching master features:", error);
      Swal.fire({ title: 'Error!', text: 'Failed to fetch features. Please try again.', icon: 'error', confirmButtonText: 'OK' });
    } finally {
      setFeatureLoading(false);
    }
  };

  const fetchPlanDetails = async () => {
    setPlanLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-plans-detils/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` },
      });
      const planDetails = response.data.data;
      let parsedFeatures = planDetails?.features?.split(",").map(Number) || "";
      setPlanData({
        name: planDetails.name || "", description: planDetails.description || "",
        html_description: planDetails.html_description || "", features: parsedFeatures,
        monthly_price: planDetails.monthly_price || "", annual_price: planDetails.annual_price || "",
        monthly_offer: planDetails.monthly_offer || "", annual_offer: planDetails.annual_offer || "",
        is_free_trial: planDetails.is_free_trial || 0, is_for_attorney: planDetails.is_for_attorney || 0,
        free_trial_days: planDetails.free_trial_days || 0,
      });
    } catch (error) {
      console.error("Error fetching plan details:", error);
      Swal.fire({ title: 'Error!', text: 'Failed to fetch plan details. Please try again.', icon: 'error', confirmButtonText: 'OK' });
    } finally {
      setPlanLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "features") {
      const featureId = parseInt(value);
      setPlanData((prevData) => {
        const currentFeatures = [...prevData.features];
        if (checked) { if (!currentFeatures.includes(featureId)) currentFeatures.push(featureId); }
        else { const index = currentFeatures.indexOf(featureId); if (index > -1) currentFeatures.splice(index, 1); }
        return { ...prevData, features: currentFeatures };
      });
    } else if (name === "is_free_trial") {
      setPlanData((prevData) => ({ ...prevData, is_free_trial: checked ? 1 : 0 }));
    } else if (name === "is_for_attorney") {
      setPlanData((prevData) => ({ ...prevData, is_for_attorney: checked ? 1 : 0 }));
    } else {
      setPlanData((prevData) => ({ ...prevData, [name]: type === "checkbox" ? checked : value }));
    }
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Plan Name is required";
    if (!monthly_price) newErrors.monthly_price = "Monthly Price is required";
    if (!annual_price) newErrors.annual_price = "Annual Price is required";
    if (features.length === 0) newErrors.features = "At least one feature is required";
    if (monthly_price && isNaN(monthly_price)) newErrors.monthly_price = "Monthly Price must be a valid number";
    if (annual_price && isNaN(annual_price)) newErrors.annual_price = "Annual Price must be a valid number";
    if (monthly_offer && isNaN(monthly_offer)) newErrors.monthly_offer = "Monthly Offer must be a valid number";
    if (annual_offer && isNaN(annual_offer)) newErrors.annual_offer = "Annual Offer must be a valid number";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditFeature = async (featureId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/get-features-details/${featureId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` },
      });
      const featureData = response.data.data;
      const { value: formValues } = await Swal.fire({
        title: 'Edit Feature',
        html: `
          <div>
            <!-- Basic Info -->
            <div class="ef-section-label">Basic Information</div>

            <div class="ef-field">
              <label class="ef-label" for="swal-input-name">Feature Name <span>*</span></label>
              <input id="swal-input-name" class="ef-input" value="${featureData.name}" placeholder="e.g. Unlimited Storage" />
            </div>

            <div class="ef-field">
              <label class="ef-label" for="swal-input-description">Description <span>*</span></label>
              <textarea id="swal-input-description" class="ef-textarea" placeholder="Brief description of what this feature offers…">${featureData.description}</textarea>
            </div>

            <div class="ef-divider"></div>

            <!-- Technical -->
            <div class="ef-section-label">Technical Details</div>

            <div class="ef-grid-2">
              <div class="ef-field">
                <label class="ef-label" for="swal-input-key">
                  Feature Key <span>*</span>
                  <span class="ef-key-hint">lowercase_snake</span>
                </label>
                <input id="swal-input-key" class="ef-input" value="${featureData.feature_key}" placeholder="e.g. storage_limit" />
              </div>

              <div class="ef-field">
                <label class="ef-label" for="swal-input-type">Feature Type <span>*</span></label>
                <select id="swal-input-type" class="ef-select">
                  <option value="numeric"  ${featureData.feature_type === 'numeric'  ? 'selected' : ''}>Numeric</option>
                  <option value="text"     ${featureData.feature_type === 'text'     ? 'selected' : ''}>Text</option>
                  <option value="boolean"  ${featureData.feature_type === 'boolean'  ? 'selected' : ''}>Boolean</option>
                </select>
              </div>
            </div>

            <div class="ef-field">
              <label class="ef-label" for="swal-input-default">Default Value</label>
              <input id="swal-input-default" class="ef-input" value="${featureData.default_value}" placeholder="e.g. 100 / true / unlimited" />
            </div>

            <div class="ef-divider"></div>

            <!-- Status -->
            <div class="ef-section-label">Status</div>

            <label class="ef-toggle-row" for="swal-input-active">
              <input id="swal-input-active" type="checkbox" ${featureData.is_active ? 'checked' : ''} />
              <span class="ef-toggle-label">Active</span>
              <span class="ef-toggle-hint">Toggle to enable or disable this feature</span>
            </label>
          </div>
        `,
        width: '580px',
        padding: '0',
        focusConfirm: false,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: '✓ Update Feature',
        cancelButtonText: 'Cancel',
        customClass: {
          container: 'ef-swal-container',
          backdrop:  'ef-swal-backdrop',
          popup:     'ef-swal-popup',
        },
        preConfirm: () => {
          const name = document.getElementById('swal-input-name').value.trim();
          const description = document.getElementById('swal-input-description').value.trim();
          const feature_key = document.getElementById('swal-input-key').value.trim();
          const feature_type = document.getElementById('swal-input-type').value;
          const default_value = document.getElementById('swal-input-default').value.trim();
          const is_active = document.getElementById('swal-input-active').checked;
          if (!name) { Swal.showValidationMessage('Feature Name is required'); return false; }
          if (!description) { Swal.showValidationMessage('Description is required'); return false; }
          if (!feature_key) { Swal.showValidationMessage('Feature Key is required'); return false; }
          const featureKeyRegex = /^[a-z][a-z0-9_]*$/;
          if (!featureKeyRegex.test(feature_key)) { Swal.showValidationMessage('Feature Key should start with a letter and contain only lowercase letters, numbers, and underscores'); return false; }
          if (feature_type === 'numeric' && default_value && isNaN(default_value)) { Swal.showValidationMessage('Default Value must be a valid number for numeric feature type'); return false; }
          if (feature_type === 'boolean' && default_value && !['true', 'false', '1', '0'].includes(default_value.toLowerCase())) { Swal.showValidationMessage('Default Value for boolean type should be true/false or 1/0'); return false; }
          return { name, description, feature_key, feature_type, default_value, is_active: is_active ? 1 : 0 };
        }
      });
      if (formValues) {
        try {
          Swal.fire({ title: 'Updating Feature...', text: 'Please wait while we update the feature.', icon: 'info', allowOutsideClick: false, showConfirmButton: false, didOpen: () => { Swal.showLoading(); } });
          const updateResponse = await axios.post(`${API_BASE_URL}/update-features/${featureId}`, formValues, {
            headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}`, 'Content-Type': 'application/json' },
          });
          Swal.fire({ title: 'Success!', text: 'Feature updated successfully.', icon: 'success', confirmButtonText: 'OK' }).then(() => { fetchMasterFeatures(); });
        } catch (updateError) {
          console.error("Error updating feature:", updateError);
          const errorMessage = updateError.response?.data?.message || updateError.response?.data?.error || 'Failed to update feature. Please try again.';
          Swal.fire({ title: 'Error!', text: errorMessage, icon: 'error', confirmButtonText: 'OK' });
        }
      }
    } catch (error) {
      console.error("Error fetching feature details:", error);
      Swal.fire({ title: 'Error!', text: 'Failed to fetch feature details. Please try again.', icon: 'error', confirmButtonText: 'OK' });
    }
  };

  const checkForDuplicateFeatures = (featuresArray) => {
    const featureKeys = featuresArray.map((featureId) => {
      const feature = masterFeatures.find((f) => f.id === featureId);
      return feature?.feature_key;
    });
    const isDuplicate = featureKeys.some((key, i) => featureKeys.indexOf(key) !== i);
    const conflictingFeature = featureKeys.find((key, i) => featureKeys.indexOf(key) !== i);
    if (isDuplicate) {
      Swal.fire({ title: 'Error!', text: `Features with same key cannot be added to the plan. Please try again. Avoid Same feature type/key. Conflicting Feature Key: ${conflictingFeature}`, icon: 'error', confirmButtonText: 'OK' });
    }
    return !isDuplicate;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (!checkForDuplicateFeatures(features)) return;
    setSubmitLoading(true);
    const payload = {
      name: name.trim(), description: description.trim(), html_description: html_description.trim(), features,
      monthly_price: parseFloat(monthly_price), annual_price: parseFloat(annual_price),
      monthly_offer: monthly_offer ? parseFloat(monthly_offer) : 0,
      annual_offer: annual_offer ? parseFloat(annual_offer) : 0,
      is_free_trial: is_free_trial == 1 ? 1 : 0, is_for_attorney: is_for_attorney == 1 ? 1 : 0,
      free_trial_days: free_trial_days ? parseInt(free_trial_days) : 0,
    };
    try {
      let response;
      if (isEditMode) {
        response = await axios.post(`${API_BASE_URL}/update-plans/${id}`, payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}`, 'Content-Type': 'application/json' },
        });
      } else {
        response = await axios.post(`${API_BASE_URL}/create-subscription-plans`, payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}`, 'Content-Type': 'application/json' },
        });
      }
      Swal.fire({ title: 'Success!', text: `Plan ${isEditMode ? 'updated' : 'created'} successfully.`, icon: 'success', confirmButtonText: 'OK' })
        .then(() => { navigate('/cms/manage-subscription-plan'); });
    } catch (error) {
      console.error("Error submitting plan:", error);
      Swal.fire({ title: 'Error!', text: `Failed to ${isEditMode ? 'update' : 'create'} plan. Please try again.`, icon: 'error', confirmButtonText: 'OK' });
    } finally {
      setSubmitLoading(false);
    }
  };

  /* ── Loading state ── */
  if (planLoading) {
    return (
      <div className="main-content asp-scope">
        <div className="page-content">
          <div className="container-fluid">
            <div className="asp-page-loader">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading plan details…</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ── Main render ── */
  return (
    <>
      <style>{styles}</style>

      <div className="main-content asp-scope">
        <div className="page-content">
          <div className="container-fluid">

            {/* ── Page Header ── */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">
                    {isEditMode ? 'Edit Subscription Plan' : 'Add Subscription Plan'}
                  </h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="javascript: void(0);">CMS</a></li>
                      <li className="breadcrumb-item">
                        <Link to={"/cms/manage-subscription-plan"}>Manage Plan</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {isEditMode ? 'Edit Plan' : 'Add Plan'}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Form Card ── */}
            <div className="col-xl-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">

                      {/* Card Header */}
                      <div className="asp-card-header">
                        <div className="asp-card-icon">
                          <i className={`fas ${isEditMode ? 'fa-edit' : 'fa-plus'}`}></i>
                        </div>
                        <div>
                          <div className="asp-card-title">{isEditMode ? 'Edit Plan' : 'Add Plan'}</div>
                          <div className="asp-card-subtitle">
                            {isEditMode ? 'Update subscription plan details and features' : 'Fill in the details to create a new subscription plan'}
                          </div>
                        </div>
                        <span className={`asp-mode-badge ${isEditMode ? 'asp-mode-badge-edit' : 'asp-mode-badge-create'}`}>
                          {isEditMode ? '✏ Edit Mode' : '✦ Create Mode'}
                        </span>
                      </div>

                      {/* Form */}
                      <form onSubmit={handleSubmit}>
                        <div className="asp-form-body">

                          {/* ── Section: Basic Info ── */}
                          <div className="asp-section">
                            <div className="asp-section-label">Basic Information</div>

                            {/* Plan Name */}
                            <div className="asp-field">
                              <label className="asp-label" htmlFor="taskname">
                                Plan Name <span className="asp-req">*</span>
                              </label>
                              <input
                                id="taskname" name="name" type="text" value={name}
                                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                placeholder="Enter Plan Name…"
                                onChange={handleInputChange}
                              />
                              {errors.name && <div className="asp-error">{errors.name}</div>}
                            </div>

                            {/* Description */}
                            <div className="asp-field">
                              <label className="asp-label" htmlFor="description">Description</label>
                              <textarea
                                id="description" name="description" rows={4} value={description}
                                className={`form-control ${errors.description ? "is-invalid" : ""}`}
                                placeholder="Enter a short description of this plan…"
                                onChange={handleInputChange}
                              />
                              {errors.description && <div className="asp-error">{errors.description}</div>}
                            </div>

                            {/* HTML Description */}
                            <div className="asp-field">
                              <label className="asp-label" htmlFor="html_description">
                                Description <span style={{ fontSize: 11, fontWeight: 600, color: '#8b92a9', background: '#f0f2f7', borderRadius: 5, padding: '1px 6px', marginLeft: 4 }}>HTML</span>
                              </label>
                              <Editor
                                value={html_description}
                                init={TINYMCE_CONFIG}
                                onEditorChange={(content) => {
                                  setPlanData((prev) => ({ ...prev, html_description: content }));
                                  if (errors.html_description)
                                    setErrors((prev) => ({ ...prev, html_description: "" }));
                                }}
                              />
                              {errors.html_description && <div className="asp-error">{errors.html_description}</div>}
                            </div>

                            {/* For Attorney */}
                            <div className="asp-field">
                              <label className="asp-label" htmlFor="is_for_attorney">For Attorney / Professional</label>
                              <div className="asp-toggle-row">
                                <input
                                  id="is_for_attorney" name="is_for_attorney" type="checkbox"
                                  value={is_for_attorney} checked={is_for_attorney === 1}
                                  className={`form-check-input ${errors.is_for_attorney ? "is-invalid" : ""}`}
                                  style={{ width: "20px", height: "20px" }}
                                  onChange={handleInputChange}
                                />
                                <div className="asp-toggle-info">
                                  <small>
                                    <strong className="ok">Check</strong> this box to assign this plan to <strong>Attorneys / Lawyers</strong>.&nbsp;
                                    <strong className="no">Uncheck</strong> to assign it to <strong>Professionals</strong>.
                                  </small>
                                </div>
                              </div>
                              {errors.is_for_attorney && <div className="asp-error">{errors.is_for_attorney}</div>}
                            </div>
                          </div>

                          {/* ── Section: Pricing ── */}
                          <div className="asp-section">
                            <div className="asp-section-label">Pricing</div>

                            <div className="asp-price-grid">
                              {/* Monthly Price */}
                              <div className="asp-field">
                                <label className="asp-label" htmlFor="monthly_price">
                                  Monthly Price <span className="asp-req">*</span>
                                </label>
                                <input
                                  id="monthly_price" name="monthly_price" type="number" step="0.01" value={monthly_price}
                                  className={`form-control ${errors.monthly_price ? "is-invalid" : ""}`}
                                  placeholder="0.00"
                                  onChange={handleInputChange}
                                />
                                {errors.monthly_price && <div className="asp-error">{errors.monthly_price}</div>}
                              </div>

                              {/* Annual Price */}
                              <div className="asp-field">
                                <label className="asp-label" htmlFor="annual_price">
                                  Annual Price <span className="asp-req">*</span>
                                </label>
                                <input
                                  id="annual_price" name="annual_price" type="number" step="0.01" value={annual_price}
                                  className={`form-control ${errors.annual_price ? "is-invalid" : ""}`}
                                  placeholder="0.00"
                                  onChange={handleInputChange}
                                />
                                {errors.annual_price && <div className="asp-error">{errors.annual_price}</div>}
                              </div>

                              {/* Monthly Offer */}
                              <div className="asp-field">
                                <label className="asp-label" htmlFor="monthly_offer">Monthly Offer</label>
                                <input
                                  id="monthly_offer" name="monthly_offer" type="number" step="0.01" value={monthly_offer}
                                  className={`form-control ${errors.monthly_offer ? "is-invalid" : ""}`}
                                  placeholder="0.00 (optional)"
                                  onChange={handleInputChange}
                                />
                                {errors.monthly_offer && <div className="asp-error">{errors.monthly_offer}</div>}
                              </div>

                              {/* Annual Offer */}
                              <div className="asp-field">
                                <label className="asp-label" htmlFor="annual_offer">Annual Offer</label>
                                <input
                                  id="annual_offer" name="annual_offer" type="number" step="0.01" value={annual_offer}
                                  className={`form-control ${errors.annual_offer ? "is-invalid" : ""}`}
                                  placeholder="0.00 (optional)"
                                  onChange={handleInputChange}
                                />
                                {errors.annual_offer && <div className="asp-error">{errors.annual_offer}</div>}
                              </div>
                            </div>
                          </div>

                          {/* ── Section: Free Trial ── */}
                          <div className="asp-section">
                            <div className="asp-section-label">Free Trial</div>

                            {/* Is Free Trial */}
                            <div className="asp-field">
                              <label className="asp-label" htmlFor="is_free_trial">Enable Free Trial</label>
                              <div className="asp-toggle-row">
                                <input
                                  id="is_free_trial" name="is_free_trial" type="checkbox"
                                  value={is_free_trial} checked={is_free_trial === 1}
                                  className={`form-check-input ${errors.is_free_trial ? "is-invalid" : ""}`}
                                  style={{ width: "20px", height: "20px" }}
                                  onChange={handleInputChange}
                                />
                                <div className="asp-toggle-info">
                                  <small>Check this box if you want to offer a <strong>Free Trial</strong> period for this plan.</small>
                                </div>
                              </div>
                              {errors.is_free_trial && <div className="asp-error">{errors.is_free_trial}</div>}
                            </div>

                            {/* Free Trial Days */}
                            <div className="asp-field" style={{ maxWidth: 280 }}>
                              <label className="asp-label" htmlFor="free_trial_days">Free Trial Days</label>
                              <input
                                id="free_trial_days" name="free_trial_days" type="number" step="1" value={free_trial_days}
                                className={`form-control ${errors.free_trial_days ? "is-invalid" : ""}`}
                                placeholder="e.g. 14"
                                onChange={handleInputChange}
                              />
                              {errors.free_trial_days && <div className="asp-error">{errors.free_trial_days}</div>}
                            </div>
                          </div>

                          {/* ── Section: Features ── */}
                          <div className="asp-section">
                            <div className="asp-section-label">Plan Features</div>

                            {featureLoading ? (
                              <div className="asp-feature-grid">
                                {Array.from({ length: 6 }).map((_, i) => (
                                  <div key={i} style={{ background: '#f8f9fe', border: '1.5px solid #e2e6f0', borderRadius: 12, padding: 14 }}>
                                    <span className="asp-skeleton" style={{ width: '60%', height: 14, marginBottom: 8, display: 'block' }} />
                                    <span className="asp-skeleton" style={{ width: '90%', height: 11 }} />
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="asp-feature-grid">
                                {masterFeatures?.sort((a, b) => a.feature_order - b.feature_order)?.map((item) => (
                                  <div
                                    key={item?.id}
                                    className={`asp-feature-card ${features.includes(item?.id) ? "asp-feature-checked" : ""}`}
                                  >
                                    <div className="asp-feature-card-top">
                                      <label className="asp-feature-check-label" htmlFor={`feature-${item.id}`}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`feature-${item.id}`}
                                          name="features"
                                          value={item?.id}
                                          checked={features.includes(item?.id)}
                                          onChange={handleInputChange}
                                        />
                                        <span className="asp-feature-name">{item?.name}</span>
                                      </label>
                                      <button
                                        type="button"
                                        className="asp-feature-edit-btn"
                                        onClick={() => handleEditFeature(item.id)}
                                        title="Edit Feature"
                                      >
                                        <i className="fas fa-edit"></i>
                                      </button>
                                    </div>
                                    <div className="asp-feature-desc">
                                      {item?.description?.length > 60
                                        ? `${item.description.substring(0, 60)}…`
                                        : item?.description}
                                    </div>
                                    <div className="asp-feature-selected-tick">✓</div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {errors.features && <div className="asp-error" style={{ marginTop: 12 }}>{errors.features}</div>}
                          </div>

                        </div>{/* end asp-form-body */}

                        {/* ── Footer Buttons ── */}
                        <div className="asp-form-footer">
                          <Link to="/cms/manage-subscription-plan" className="asp-btn asp-btn-cancel">
                            Cancel
                          </Link>
                          <button
                            type="submit"
                            className="asp-btn asp-btn-submit"
                            disabled={submitLoading}
                          >
                            {submitLoading ? (
                              <>
                                <span className="spinner-border spinner-border-sm" role="status">
                                  <span className="visually-hidden">Loading…</span>
                                </span>
                                {isEditMode ? 'Updating…' : 'Creating…'}
                              </>
                            ) : (
                              isEditMode ? '✓ Update Plan' : '+ Add Plan'
                            )}
                          </button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubscriptionPlanNew;
